import { t } from '../i18n/index.ts'

export type MessageTimerOption = {
  ttlMs: number | null
  label: string
}

const TIMER_KEYS: ReadonlyArray<{ ttlMs: number | null; key: string }> = [
  { ttlMs: null, key: 'chat_timer_off' },
  { ttlMs: 15_000, key: 'chat_timer_15s' },
  { ttlMs: 30_000, key: 'chat_timer_30s' },
  { ttlMs: 60_000, key: 'chat_timer_1m' },
  { ttlMs: 120_000, key: 'chat_timer_2m' },
]

export const MESSAGE_TIMER_OPTIONS: MessageTimerOption[] = TIMER_KEYS.map((opt) => ({
  ttlMs: opt.ttlMs,
  get label() {
    return t(opt.key)
  },
}))

/** TTL effimero per contatto (ms). null = OFF. */
const ttlByContact = new Map<string, number | null>()

export function getMessageTimerTtl(contactId: string): number | null {
  const id = contactId.trim()
  if (!id) return null
  return ttlByContact.has(id) ? (ttlByContact.get(id) ?? null) : null
}

export function setMessageTimerTtl(contactId: string, ttlMs: number | null): void {
  const id = contactId.trim()
  if (!id) return
  if (ttlMs == null || !Number.isFinite(ttlMs) || ttlMs <= 0) {
    ttlByContact.set(id, null)
    return
  }
  ttlByContact.set(id, Math.trunc(ttlMs))
}
